require('./angulartics-google-analytics')
module.exports = 'angulartics.google.analytics'



//////////////////
// WEBPACK FOOTER
// ../~/angulartics-google-analytics/lib/index.js
// module id = 95
// module chunks = 1